import { render, staticRenderFns } from "./I18nKeyMap.vue?vue&type=template&id=6728f3b7&scoped=true"
import script from "./I18nKeyMap.vue?vue&type=script&lang=js"
export * from "./I18nKeyMap.vue?vue&type=script&lang=js"
import style0 from "./I18nKeyMap.vue?vue&type=style&index=0&id=6728f3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728f3b7",
  null
  
)

export default component.exports